const STORAGE_ASSET_MARKERS = ['/storage/v1/object/public/assets/', '/storage/v1/render/image/public/assets/'] as const

// Supabase transform URLs take the path relative to the assets bucket. Keep
// nested object keys intact (for example popups/2/image.webp), while retaining
// the old filename fallback for unexpected absolute URLs.
export const storageAssetPath = (source: string): string => {
  let pathname: string
  let isAbsolute = false

  try {
    pathname = new URL(source).pathname
    isAbsolute = true
  } catch {
    pathname = source.split(/[?#]/, 1)[0]
  }

  for (const marker of STORAGE_ASSET_MARKERS) {
    const markerIndex = pathname.indexOf(marker)
    if (markerIndex >= 0) {
      return pathname.slice(markerIndex + marker.length)
    }
  }

  if (isAbsolute) {
    return pathname.split('/').filter(Boolean).at(-1) ?? ''
  }

  return pathname.replace(/^\/+/, '')
}
